import { AxiosError } from 'axios';
import { eventsRequest } from '../../utils/eventsRequest';
import { ErrorResponse } from '../../types';

interface Coupon {
    location: {
      id: number;
      name: string;
    } | null;
    type: number | null;
    id: string;
    code: string;
    amount: number;
    locationId: number;
}

interface ResponseData {
    data: {
        data: Coupon[];
    };
}

const getCouponId = async (couponCode: string) => {
  let arrayResponse = {
    success: false,
    message: 'Coupon not found.',
    data: null as Coupon | null,
  };

  try {
    const response = await eventsRequest<ResponseData>(`/coupons?search=`+couponCode , 'get');

    if (response.status === 200 && response.data.data.data.length > 0) {
      const coupon = response.data.data.data.find(c => c.code === couponCode);
      if (coupon) {
        arrayResponse.success = true;
        arrayResponse.message = 'Coupon found.';
        arrayResponse.data = coupon;
      }
    }

    return arrayResponse;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    if (axiosError.response && axiosError.response.status === 400) {
        arrayResponse.message = axiosError.response.data.message;
    }
    return arrayResponse;
  }
};

export default getCouponId;
